import React, { useState } from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  updateFloor,
  addFloor,
  clearFloor,
  loadBuildingsList,
} from "../../../actions/adminAction";
import { setAlert } from "../../../actions/alertAction";
import Alert from "../../../layouts/Alert";
import VirbrixliteConfig from "./components/VirbrixliteConfig";

const FloorForm = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const floor = useSelector((state) => state.admin.floor);
  const floorLoading = useSelector((state) => state.admin.floorLoading);

  const buildingsList = useSelector((state) => state.admin.buildingsList);

  const [formData, setFormData] = useState({
    name: floor === null ? "" : floor.floor !== undefined ? floor.floor : "",
    id: floor === null ? "" : floor.id !== undefined ? floor.id : "",
    image: floor === null ? "" : floor.image !== undefined ? floor.image : "",
    displayImage:
      floor === null
        ? ""
        : floor.displayImage !== undefined
          ? floor.displayImage
          : "",
    buildings_id:
      floor === null
        ? ""
        : floor.buildings_id !== undefined
          ? floor.buildings_id
          : "1",
    modelUrl:
      floor === null
        ? ""
        : floor.scans !== undefined && floor.scans.length > 0
          ? floor.scans[0].file_url
          : "",
  });

  useEffect(() => {
    if (buildingsList.length === 0) {
      dispatch(loadBuildingsList());
    }
  }, [buildingsList]);

  useEffect(() => {
    if (
      location.pathname.includes("add") &&
      !formData.buildings_id &&
      buildingsList.length > 0
    ) {
      setFormData((currentData) => ({
        ...currentData,
        buildings_id: String(buildingsList[0].id),
      }));
    }
  }, [buildingsList, formData.buildings_id, location.pathname]);

  const [img, setImg] = useState({ data: null, preview: null });

  const [display_img, setDisplayImg] = useState({ data: null, preview: null });

  // Lite tabs configuration state
  const [liteTabs, setLiteTabs] = useState([]);

  const onChange = (e) => {
    console.log("formData", formData);
    setFormData({ ...formData, [e.target.id]: e.target.value });
  };

  const { id, name, image, displayImage, buildings_id, modelUrl } = formData;

  const onSubmit = (e) => {
    e.preventDefault();
    window.scrollTo(0, 0);
    if (location.pathname.includes("add")) {
      console.log("add");
      const reader = new FileReader();
      reader.readAsDataURL(img.data);
      reader.onloadend = () => {
        const reader2 = new FileReader();
        reader2.readAsDataURL(display_img.data);
        reader2.onloadend = () => {
          const data = {
            floor: name,
            buildings_id,
            image: { name: img.data.name, data: reader.result },
            displayImage: { name: display_img.data.name, data: reader2.result },
            VirbrixliteLink: liteTabs,
            modelUrl,
          };
          console.log(data);
          dispatch(addFloor(data));
          setFormData({ name: "", image: "", displayImage: "", modelUrl: "" });
          navigate("/admin/floors");
        };
      };
    } else if (location.pathname.includes("edit")) {
      if (img.data && display_img.data) {
        const reader = new FileReader();
        reader.readAsDataURL(img.data);
        reader.onloadend = () => {
          const reader2 = new FileReader();
          reader2.readAsDataURL(display_img.data);
          reader2.onloadend = () => {
            const data = {
              floor: name,
              buildings_id,
              image: { name: img.data.name, data: reader.result },
              displayImage: {
                name: display_img.data.name,
                data: reader2.result,
              },
              VirbrixliteLink: liteTabs,
              modelUrl,
            };
            console.log(data);
            dispatch(updateFloor(id, data));
            setFormData({
              name: "",
              image: "",
              displayImage: "",
              modelUrl: "",
            });
            navigate("/admin/floors");
          };
        };
      } else if (img.data && !display_img.data) {
        const reader = new FileReader();
        reader.readAsDataURL(img.data);
        reader.onloadend = () => {
          const data = {
            floor: name,
            buildings_id,
            image: { name: img.data.name, data: reader.result },
            VirbrixliteLink: liteTabs,
            modelUrl,
          };
          console.log(data);
          dispatch(updateFloor(id, data));
          setFormData({ name: "", image: "", displayImage: "" });
          navigate("/admin/floors");
        };
      } else if (!img.data && display_img.data) {
        const reader = new FileReader();
        reader.readAsDataURL(display_img.data);
        reader.onloadend = () => {
          const data = {
            floor: name,
            buildings_id,
            displayImage: { name: display_img.data.name, data: reader.result },
            VirbrixliteLink: liteTabs,
            modelUrl,
          };
          console.log(data);
          dispatch(updateFloor(id, data));
          setFormData({ name: "", image: "", displayImage: "", modelUrl: "" });
          navigate("/admin/floors");
        };
      } else {
        dispatch(
          updateFloor(id, {
            floor: name,
            modelUrl: modelUrl,
            VirbrixliteLink: liteTabs,
          })
        );
        setFormData({ name: "", image: "", modelUrl: "" });
        navigate("/admin/floors");
      }
    }
  };

  useEffect(() => {
    if (floor == null && location.pathname.includes("edit")) {
      navigate("/admin/floors");
    }
  }, [floor]);

  return (
    <div className="admin-card px-sm-5 py-sm-4 p-2 me-0 mt-0 mb-0 text-main">
      <div className="mb-2 ">
        <h6 className="text-main my-3">Admin / Floors / Floor</h6>
        <div className="d-sm-flex  w-100 align-items-center justify-content-between">
          <div className="d-flex mb-2 mb-sm-0 align-items-center">
            <div
              className="admin-back mx-2  rounded-circle border border-2 d-flex align-items-center justify-content-center"
              onClick={() => {
                navigate(-1);
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                fill="currentColor"
                className="bi bi-arrow-left-short"
                viewBox="0 0 16 16"
              >
                <path
                  fillRule="evenodd"
                  d="M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5z"
                />
              </svg>
            </div>
            <h4 className="m-0">
              {location.pathname.includes("add") ? "Add Floor" : "Edit"}
            </h4>
          </div>
        </div>
      </div>
      <form
        className="w-100 mb-2 h-max-content"
        onSubmit={(e) => onSubmit(e)}
      >
        <Alert />

        {/* Floor Configuration */}
        <div className="card w-100 p-2 p-sm-3 p-lg-4 shadow-lg border-0 admin-list mb-3">
          <h5 className="text-main fw-bold mb-3">Floor Configuration</h5>
          <div className="row">
            <div className="col-lg-4 col">
              <div className="mb-3">
                <h6 className="text-main fw-bold">Name</h6>
                <input
                  type="text"
                  className="form-control rounded admin-list text-main"
                  id="name"
                  placeholder="Enter name..."
                  required
                  value={name}
                  onChange={(e) => onChange(e)}
                />
              </div>
            </div>
            <div className="col-lg-4 col">
              <div className="mb-3">
                <h6 className="text-main fw-bold">360° Walkthrough URL</h6>
                <input
                  type="text"
                  className="form-control rounded admin-list text-main"
                  id="modelUrl"
                  placeholder="Enter 360° walkthrough URL..."
                  value={modelUrl}
                  onChange={(e) => onChange(e)}
                />
              </div>
            </div>
          </div>
          {location.pathname.includes("add") && buildingsList.length > 0 && (
            <div className="row">
              <div className="col-lg-4 col">
                <div className="mb-3">
                  <h6 className="text-main fw-bold">Building</h6>
                  <select
                    name="buildings_id"
                    id="buildings_id"
                    required
                    className="form-select rounded admin-list text-main"
                    value={buildings_id}
                    onChange={(e) => onChange(e)}
                  >
                    {buildingsList.map((building) => (
                      <option
                        key={building.id}
                        value={building.id}
                      >
                        {building.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
          )}
          <div className="row">
            <div className="col-lg-4 col">
              <div className="mb-3">
                <h6 className="text-main fw-bold">Image</h6>
                <input
                  type="file"
                  className="form-control rounded admin-list text-main"
                  id="image"
                  accept="image/*"
                  value={""}
                  onChange={(e) => {
                    const img = {
                      preview: URL.createObjectURL(e.target.files[0]),
                      data: e.target.files[0],
                    };
                    setImg(img);
                    console.log(img);
                  }}
                />
              </div>
              {img.preview && (
                <div className="">
                  <h6 className="text-main fw-bold">Preview</h6>
                  <div
                    className=""
                    style={{
                      backgroundImage: `url(${img.preview})`,
                      height: "200px",
                      width: "400px",
                      backgroundSize: "cover",
                      position: "relative",
                    }}
                  >
                    <div className=" position-absolute top-0 w-100 d-flex align-items-center justify-content-end">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="#0098c1"
                        className="bi bi-x-circle-fill m-2 cursor-pointer "
                        viewBox="0 0 16 16"
                        onClick={() => {
                          setImg({
                            data: null,
                            preview: null,
                          });
                        }}
                      >
                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z" />
                      </svg>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div className="col-lg-4 col">
              <div className="mb-3">
                <h6 className="text-main fw-bold">Display Image</h6>
                <input
                  type="file"
                  className="form-control rounded admin-list text-main"
                  id="displayImage"
                  accept="image/*"
                  value={""}
                  onChange={(e) => {
                    const img = {
                      preview: URL.createObjectURL(e.target.files[0]),
                      data: e.target.files[0],
                    };
                    setDisplayImg(img);
                    console.log(img);
                  }}
                />
              </div>
              {display_img.preview && (
                <div className="">
                  <h6 className="text-main fw-bold">Preview</h6>
                  <div
                    className=""
                    style={{
                      backgroundImage: `url(${display_img.preview})`,
                      height: "200px",
                      width: "400px",
                      backgroundSize: "cover",
                      position: "relative",
                    }}
                  >
                    <div className=" position-absolute top-0 w-100 d-flex align-items-center justify-content-end">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="#0098c1"
                        className="bi bi-x-circle-fill m-2 cursor-pointer "
                        viewBox="0 0 16 16"
                        onClick={() => {
                          setDisplayImg({
                            data: null,
                            preview: null,
                          });
                        }}
                      >
                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z" />
                      </svg>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className="d-flex mb-3">
            {!location.pathname.includes("add") && (
              <>
                <div className="">
                  <h6 className="text-main fw-bold">Image</h6>
                  <div
                    className=""
                    style={{
                      backgroundImage: `url(${image})`,
                      height: "200px",
                      width: "400px",
                      backgroundSize: "cover",
                      position: "relative",
                    }}
                  ></div>
                </div>
                <div className="">
                  <h6 className="text-main fw-bold">Display Image</h6>
                  <div
                    className=""
                    style={{
                      backgroundImage: `url(${displayImage})`,
                      height: "200px",
                      width: "400px",
                      backgroundSize: "cover",
                      position: "relative",
                    }}
                  ></div>
                </div>
              </>
            )}
          </div>
        </div>

        {/* Virbrixlite Configuration */}
        <div className="card w-100 p-2 p-sm-3 p-lg-4 shadow-lg border-0 admin-list mb-3">
          <h5 className="text-main fw-bold mb-3">Virbrixlite Floor Configuration</h5>
          <VirbrixliteConfig
            value={floor?.VirbrixliteLink}
            onChange={setLiteTabs}
          />
        </div>

        <div className="d-flex align-items-center justify-content-center">
          <button
            type="submit"
            className="admin-list-btn-secondary text-main btn-block btn px-5"
          >
            Save
          </button>
        </div>
      </form>
    </div>
  );
};

export default FloorForm;
